
/**
 * Module dependencies.
 */

import {
  Marker as GoogleMapMarker,
  MarkerProps
} from '@react-google-maps/api';

import { assetUrlResolve } from 'src/core/utils/url-resolver';
import React, { ReactElement } from 'react';

/**
 * `Marker` component.
 */

const Marker = (props: MarkerProps): ReactElement => (
  <GoogleMapMarker
    clickable
    icon={{ url: assetUrlResolve('/static/images/marker-icon.png') }}
    {...props}
  />
);

/**
 * Export `Marker` component.
 */

export default Marker;
